import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { isWeekend, nextMonday } from 'date-fns';
import { formatDate } from '../utils/date';

export interface SidebarState {
    selectedDateIso: string;
}

const setInitialSelectedDateIso = (): string => {
    const dateFromUrl = location.pathname.replace('/', '');
    const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    const d = dateRegex.test(dateFromUrl) ? new Date(dateFromUrl) : new Date();
    const adjusted = isWeekend(d) ? nextMonday(d) : d;
    return formatDate(adjusted);
};

const initialState: SidebarState = {
    selectedDateIso: setInitialSelectedDateIso()
};

export const calendarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setDate: {
            reducer: (state, action: PayloadAction<string>) => {
                state.selectedDateIso = action.payload;
            },
            prepare: (date: string | Date) => ({
                payload: typeof date === 'string' ? date : formatDate(date)
            })
        }
    }
});

export const selectDate = createSelector(
    [(state: RootState) => state.sidebar.selectedDateIso],
    (iso) => new Date(iso)
);

export const { setDate } = calendarSlice.actions;
export default calendarSlice.reducer;
